import {
  Box,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Flex,
  FormLabel,
  Input,
} from '@chakra-ui/react';
import React, { useMemo, useState } from 'react';

import { Util, CreditAgreement } from '@finley-technologies/finley-types';

const _organizeVariableOutput = (value: Util.Primitive): string => {
  if (value === '') {
    return '[ empty string ]';
  }
  return String(value);
};

export const VariablePreviewModal = (params: {
  variables: CreditAgreement.Config.QueryResult[];
  isOpen: boolean;
  onClose: () => void;
}) => {
  const { variables, isOpen, onClose } = params;

  const [searchText, setSearchText] = useState<string>('');

  const targetVariables = useMemo(() => {
    const lowerSearchText = searchText.toLowerCase();
    const filteredVariables = variables.filter((variable) => {
      if (lowerSearchText === '') {
        return true;
      }
      return variable.name.toLowerCase().includes(lowerSearchText);
    });

    filteredVariables.sort((a, b) => a.name.localeCompare(b.name));
    return filteredVariables;
  }, [searchText, variables]);

  return (
    <Modal id="variable-preview-modal" isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent w="80vw" maxW="80vw">
        {/* 80% of the viewport width */}
        <ModalHeader>Variable Results</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb="5">
          <Box maxH="3xl">
            <Flex alignItems="center" mb="6">
              <FormLabel w="48" m="0">
                Variable Name Search:
              </FormLabel>
              <Input
                type="text"
                w="lg"
                value={searchText}
                onChange={(evt) => {
                  setSearchText(evt.target.value);
                }}
              />
            </Flex>

            <Box overflow="auto" maxH="640px">
              <Table>
                <Thead position="sticky" top={0} zIndex="docked">
                  <Tr borderBottom="1px">
                    <Th textAlign="center">Name</Th>
                    <Th textAlign="center">Value</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {targetVariables.map(({ name, value }) => (
                    <Tr key={name} borderBottom="1px">
                      <Td border="unset" whiteSpace="nowrap">
                        {name}
                      </Td>
                      <Td border="unset" whiteSpace="nowrap">
                        {_organizeVariableOutput(value)}
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </Box>
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
